import { useMemo } from "react";

import { UsePerformanceChartNodesProps } from "@ctypes";
import { useDynamicChartWidth } from "@hooks/chart";
import { i18n, Translations } from "@i18n";
import { buildLinearChart } from "@utils";

export const usePerformanceChartNodes = ({ performance }: UsePerformanceChartNodesProps) => {
  const { width } = useDynamicChartWidth();

  return useMemo(() => {
    return {
      oneDay: buildLinearChart({
        data: performance?.oneDay.nodes,
        difference: performance?.oneDay.grossReturnAbsolute,
        percentage: performance?.oneDay.grossReturnPercentage,
        label: i18n.t(Translations.PerformanceChartOneDayLabel),
        width,
      }),
      oneWeek: buildLinearChart({
        data: performance?.oneWeek.nodes,
        difference: performance?.oneWeek.grossReturnAbsolute,
        percentage: performance?.oneWeek.grossReturnPercentage,
        label: i18n.t(Translations.PerformanceChartOneWeekLabel),
        width,
      }),
      oneMonth: buildLinearChart({
        data: performance?.oneMonth.nodes,
        difference: performance?.oneMonth.grossReturnAbsolute,
        percentage: performance?.oneMonth.grossReturnPercentage,
        label: i18n.t(Translations.PerformanceChartOneMonthLabel),
        width,
      }),
      sixMonth: buildLinearChart({
        data: performance?.sixMonth.nodes,
        difference: performance?.sixMonth.grossReturnAbsolute,
        percentage: performance?.sixMonth.grossReturnPercentage,
        label: i18n.t(Translations.PerformanceChartSixMonthLabel),
        width,
      }),
      oneYear: buildLinearChart({
        data: performance?.oneYear.nodes,
        difference: performance?.oneYear.grossReturnAbsolute,
        percentage: performance?.oneYear.grossReturnPercentage,
        label: i18n.t(Translations.PerformanceChartOneYearLabel),
        width,
      }),
      fiveYear: buildLinearChart({
        data: performance?.fiveYear.nodes,
        difference: performance?.fiveYear.grossReturnAbsolute,
        percentage: performance?.fiveYear.grossReturnPercentage,
        label: i18n.t(Translations.PerformanceChartFiveYearLabel),
        width,
      }),
    };
  }, [performance, width]);
};
